export function getSiteId(rData) {
	return (rData.parameterMap && rData.parameterMap.siteId) || rData.siteId;
}

export function getAccountId(rData) {
	return (
		(rData.parameterMap && rData.parameterMap.accountId) || rData.accountId
	);
}

export function titleCase(str, sep) {
	return str
		.toLowerCase()
		.split(sep)
		.map((word) => {
			return word.charAt(0).toUpperCase() + word.slice(1);
		})
		.join('');
}

/**
 * Filters list of cookies down to the cookie with name matching cookieName param. if it exists, and returns
 * its value, if it is defined, or an empty string otherwise.
 *
 * @param cookies
 * @param cookieName
 * @returns {String} cookie name if the cookie exists, or empty string.
 */
export const getCookieValue = (cookieName = '', cookies = []) => {
	return cookies
		.filter((cookie) => cookie.name === cookieName)
		.reduce((value, cookie) => cookie.value || value, '');
};

/**
 * Returns promo code from the 'affiliate_promotions' url parameter if it exists
 *
 * @param parameterMap
 * @param parameterName
 * @returns {String} parameter value if the url parameter equal to parameterName exists, or empty string.
 */
export const getParameterValue = (parameterName = '', parameterMap = {}) =>
	parameterMap[parameterName] || '';

/**
 * Returns affiliate offer promo code if one exists in the url parameter 'affiliate_promotions'
 * or in the 'DDC.Affiliate.PromoCode' cookie.
 * Prioritizes url parameter over cookie.
 *
 * @param rData
 * @returns {String} Promo code, if one exists, or empty string
 */
export const getAffiliatePromotion = (rData = {}) => {
	return (
		getParameterValue('affiliate_promotions', rData.parameterMap) ||
		getCookieValue('DDC.Affiliate.PromoCode', rData.cookies)
	);
};

export const selectFinalPrice = (pItemArray) =>
	pItemArray?.find((item) => item.isFinalPrice);

/**
 * Determines if DR is enabled for the current page
 *
 * @param {object} siteConfigProperties
 * @param {string} pageAlias
 * @returns boolean
 */
export const isDREnabled = (siteConfigProperties, pageAlias) => {
	return Boolean(
		siteConfigProperties?.enableVDPDigitalRetailing?.trim() === 'all' ||
			siteConfigProperties?.enableVDPDigitalRetailing
				?.replaceAll(' ', '')
				.split(',')
				.includes(pageAlias)
	);
};

// Borrowed from Asish's function here:
// https://ghe.coxautoinc.com/DDC-WebPlatform/ws-track-my-offer/blob/master/src/helpers/common.js#L7-L49

// For now this is considering modern headers and vehicle toolbar to offset height
// blue-flannel has a rally task(TA3024637) to update the existing calculateHeaderOffset() to handle modern headers
// TODO: in future use calculateHeaderOffset() to calculate header height.
export const scrollToPricingDetails = () => {
	if (window?.scrollTo) {
		const handleScroll = () => {
			const target = document?.querySelector(
				'.vdp-price-purchase-detailed-pricing'
			);
			if (!target || typeof target.getBoundingClientRect !== 'function') {
				return;
			}

			// calculate header height
			const header = document.querySelector('.page-header');
			const headerHeight = header?.clientHeight || 0;

			// calculate vehicle toolbar height
			const vehicleToolbar = document.querySelector(
				'[data-widget-name="ws-vehicle-toolbar"]'
			);
			const vehicleToolbarHeight = vehicleToolbar?.clientHeight || 0;

			// default height to offset from above container
			const OFFSET_HEIGHT = 25;

			// height of page that already scrolled
			const pageYOffset = window.scrollY || 0;

			// calculate target top to scroll
			const targetTop = target.getBoundingClientRect().top;

			const heightAdj =
				targetTop +
				pageYOffset -
				(headerHeight + vehicleToolbarHeight + OFFSET_HEIGHT);

			window.scrollTo({ top: heightAdj, left: 0, behavior: 'smooth' });
		};

		handleScroll();
		// scroll again after the vehicle-toolbar is displayed
		setTimeout(() => handleScroll(), 500);
	}
};
